import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const extractTagsFromNotes = (notes: string) => {
  if (!notes) return { tags: [], cleanNotes: '' };
  
  // Try to match the tags pattern
  const tagsMatch = notes.match(/\[Tags:\s*([^\]]+)\]/);
  if (tagsMatch) {
    const tags = tagsMatch[1]
      .split(',')
      .map(tag => tag.trim())
      .filter(tag => tag.length > 0);
    
    // Remove the tags section from notes
    const cleanNotes = notes
      .replace(/\s*\[Tags:\s*[^\]]+\]\s*$/, '')
      .trim();
    
    return { tags, cleanNotes };
  }
  
  return { tags: [], cleanNotes: notes };
};
